import { modalService } from '../../framework.js';
import GuidanceRegistry from '../guidance-registry.js';
import CobraSetup from "../../cobra/CobraSetup"
import NewCobraSetup from "../../newCobra/NewCobraSetup.vue";
import { test } from 'shelljs';
import store from '../../store';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-cobra-setup",
    prompt: (guidanceItem) => getPromptText(guidanceItem),
    beforeLoad: async (component, guidanceItem) => {
        await component.refreshPermissions();
    },
    briefDescription: 'COBRA Setup',
    openAction: {
        text: null,        
        url: (guidanceItem) => `employer-cobra`,
        row: null
    },
    completeAction: {
        visible: () => true
    },
    actions: [
        {
            text: "Setup COBRA",            
            recommended: true,
            click: async(component, guidanceItem) => {
                if(store.state.employer.usesOurCobra == true){
                    await modalService.show("new-cobra-setup", NewCobraSetup);
                } else {
                    await modalService.show("cobra-setup", CobraSetup, { width: 800 });
                }
            }
        },
    ],
});

function getPromptText(guidanceItem){
    return 'Click the blue <strong>Setup COBRA</strong> button within this panel. When prompted, enter the total number of insured participants (not including dependents) that are enrolled in your medical benefits only. This number is used for COBRA administrative fee billing. Click Save.'
}



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-cobra-setup.js